import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import location from "../../../../assets/images/locationNew02.png"
import mail from "../../../../assets/images/mailNew.png"
import phone from "../../../../assets/images/phoneNew.png"
import { FormCategories, Strings, formBtnText, payrollField, starRate, tempProfileImageLink } from "../../../../constants";
import AddIcon from "../../../Add";
import getAge from "../../../../globalFunctions/getAge";
import _ from 'lodash'
import InputField from "../../components/inputField";
import { updateCoreAttribute, updateOtherAttributes, updateEditActive } from "../../../../store/actions/talents";
import StarRating from "../../components/starRating";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProfilePicture from "./profilePicture";
import dayjs from "dayjs";

const TalentCard = (props) => {
  const {
    isTalentView,
    photos,
    isPersonalInfoUpdated,
    personalInfoUserUpdated,
    isContactUpdated,
    contactUserUpdated,
    userId,
    userRating, userPayrollId,
    triggerUpdateCoreAttribute,
    triggerUpdateOtherAttributes,
    isEditActive,
    activeEditField,
    triggerUpdateEditActive,
    isTalentRegister,
    talentsData
  } = props;
  const [profileImage, setProfileImage] = useState(tempProfileImageLink);
  const [name, setName] = useState('New Talent');
  const [age, setAge] = useState('(AGE)');
  const [address, setAddress] = useState('Address, City, Country');
  const [emailAddress, setEmailAddress] = useState('email@email.com');
  const [phoneNumber, setPhoneNumber] = useState('Phone Number');
  const [bioDescription, setBioDescription] = useState('Bio');
  const [companyRating, setCompanyRating] = useState(0);
  const [payrollId, setPayrollId] = useState('');
  const [reset, setReset] = useState(false);
  const baseUrl = process.env.REACT_APP_API_URL;
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");

  useEffect(() => {
    setCompanyRating(userRating);
    setPayrollId(userPayrollId);
  }, [userRating, userPayrollId])
  
  useEffect(() => {
    if (!isPersonalInfoUpdated && !isContactUpdated) {
      setReset(true);
    } else {
      setReset(false);
    }
  }, [isPersonalInfoUpdated, isContactUpdated])

  useEffect(() => {
    let primaryImageObj = photos && photos.find(photo => photo.primary);
    if (!primaryImageObj) {
      primaryImageObj = photos[0]
    }
    if (primaryImageObj && primaryImageObj?.fileLink) {
      setProfileImage(`${baseUrl}${primaryImageObj?.fileLink}`);
    } else {
      setProfileImage(tempProfileImageLink);
    }
  }, [photos, baseUrl])

  useEffect(() => {
    if (isPersonalInfoUpdated) {
      const personalUserData = _.cloneDeep(personalInfoUserUpdated);
      const personalInfoCore = personalUserData[FormCategories.core];
      const personalInfoBio = personalUserData[FormCategories.bio];
      const personalInfoUncategorized = personalUserData[FormCategories.uncategorized];
      let firstName = '', lastName = '';
      personalInfoCore && personalInfoCore.forEach(coreVal => {
        if (coreVal.id === Strings.firstName && coreVal.value) {
          firstName = coreVal.value
        }
        if (coreVal.id === Strings.lastName && coreVal.value) {
          lastName = coreVal.value
        }
      })
      if (firstName || lastName) {
        setName(`${firstName} ${lastName}`);
      }
      if (personalInfoBio.value) {
        setBioDescription(personalInfoBio.value);
      }
      personalInfoUncategorized && personalInfoUncategorized.forEach(uncategorized => {
        uncategorized.forEach(field => {
          if (field.label === Strings.dob && field.value) {
            setAge(`(${getAge(field.value)}yo)`);
          }
        })
      })
    }
  }, [isPersonalInfoUpdated, personalInfoUserUpdated])
  
  useEffect(() => {
    if (isContactUpdated) {
      const contactData = _.cloneDeep(contactUserUpdated);
      const contactInfo = contactData[FormCategories.contact];
      const contactAddressInfo = contactData[FormCategories.residentialAddress];
      
      contactInfo && contactInfo.forEach(contact => {
        if (contact.label === Strings.contactNumber && contact.value) {
          setPhoneNumber(contact.value);
        }
        if (contact.label === Strings.email && contact.value) {
          setEmailAddress(contact.value);
        }
      });
      let streetAddress = '', city = '', state = '';
      contactAddressInfo && contactAddressInfo.addressFields.forEach(addressFields => {
        addressFields.forEach(field => {
          if (field.label === Strings.streetAddress && field.value) {
            streetAddress = field.value;
          }
          if (field.label === Strings.city && field.value) {
            city = field.value;
          }
          if (field.label === Strings.state && field.optionSelection) {
            state = field.optionSelection;
          }
        })
      })
      if (streetAddress || city || state) {
        setAddress(`${streetAddress}${city && ', '}${city}${state && ', '}${state}`);
      }
    }
  }, [isContactUpdated, contactUserUpdated])

  useEffect(() => {
    if (!talentsData?.length || !userId) return;

    const talent = talentsData.find(t => t.uuid === userId);

    if (talent?.created_at) {
      setCreatedAt(dayjs(talent.created_at).format("MM-DD-YYYY"));
    } else {
      setCreatedAt("");
    }

    if (talent?.local_most_recent_shift_worked_at) {
      setUpdatedAt(dayjs(talent.local_most_recent_shift_worked_at).format("MM-DD-YYYY"));
    } else {
      setUpdatedAt("N/A");
    }
  }, [talentsData, userId]);

  const onChangeStarRating = (id, value, isOptionUpdate=false) => {}

  const onSaveStarRating = (id, value, isValueEdited, name, isOptionUpdate=false, optionList=[]) => {
    const actualPayload = {
      'uuid': userId,
      'company_rating': parseFloat(value)
    }
    const payload = {
      actualPayload: actualPayload,
      onSuccess: () => {
        triggerUpdateOtherAttributes({ rating: parseFloat(value), payroll: payrollId })
      },
      onError: () => {
      }
    }
    triggerUpdateCoreAttribute(payload);
  }

  const onChangePayroll = (id, value) => {}

  const onSavePayroll = (id, value, isValueEdited, name) => {
    const actualPayload = {
      'uuid': userId,
      'payroll_reference': value.toString()
    }
    const payload = {
      actualPayload: actualPayload,
      onSuccess: () => {
        triggerUpdateOtherAttributes({ rating: companyRating, payroll: value.toString() })
      },
      onError: () => {
      }
    }
    triggerUpdateCoreAttribute(payload);
  }

  const setActiveEdit = async (activeField="", isActive=false) => {
    const payload = {
      isEditActive: isActive,
      activeEditField: activeField
    }
    await triggerUpdateEditActive(payload);
  };

  const onFieldBlur = () => {
    if (isTalentView && isEditActive && activeEditField) {
      toast.warn(`${activeEditField} has been edited. Click Save to apply changes.`);
    }
  }

  return (
    <div className="flex">
      <ProfilePicture
        image={profileImage}
        userId={userId}
        isTalentView={isTalentView}
        isTalentRegister={isTalentRegister}
      />
      <div className="p-3 pl-0 w-full">
        <div className="flex flex-row justify-between mb-2 ml-4">
          <div className={`${isTalentView ? 'flex' : 'hidden'} mt-3`}>
            <p className='text-sm pt-[6px] text-grayNeutral font-medium'>PRID #</p>
            {
              payrollField && isTalentView &&
              <InputField name={payrollField?.uuid} id={payrollField?.uuid} onChange={onChangePayroll} placeholder='Not assigned' defaultValue={payrollId} type='text'
                maxAllowed={payrollField.maxAllowed} minAllowed={payrollField.minAllowed} required={payrollField.required} isReadOnly={isTalentView} showEditIcon={isTalentView} saveEdit={onSavePayroll}
                fieldCustomStyle="!w-[88px] !text-grayNeutral !font-medium" editCustomStyle="!mt-1.5" editSaveCustomStyle="!flex !mt-2"
                onFieldBlur={onFieldBlur} onEditClick={setActiveEdit} onCancelEdit={setActiveEdit} label="PRID"
              />
            }
          </div>
          <div className={`${isTalentView ? 'flex' : 'hidden'} justify-end`}>
            <div className="flex flex-col text-[13px] text-right gap-2">
              {createdAt && <span>Created: {createdAt}</span>}
              {updatedAt && <span>Last event: {updatedAt}</span>}
            </div>
          </div>
        </div>
        <div className={`${isTalentView ? 'mt-2' : 'mt-12'} flex mb-2`}>
          <h3 className="text-header leading-8 font-inter font-semibold mr-2 ml-4 capitalize">
            {name}
          </h3>
          <h3 className="flex items-center font-inter text-2xl font-normal text-grayNeutral">
            {age}
          </h3>
          {isTalentView &&
            <div className="w-auto h-auto ml-4 flex">
              <StarRating options={starRate.options} optionList={starRate.optionsList} name={starRate?.uuid} id={starRate?.uuid} onChangeOption={onChangeStarRating} defaultValue={Boolean(companyRating) && companyRating}
                isReadOnly={isTalentView} showEditIcon={isTalentView} saveEdit={onSaveStarRating} required={starRate.required} defaultCustomStyle="mt-0" editCustomStyle="mt-[1px]" editSaveCustomStyle="!flex !mt-2"
                onFieldBlur={onFieldBlur} onEditClick={setActiveEdit} onCancelEdit={setActiveEdit} label="Star Rating"
              />
            </div>
          }
        </div>
        <div className="flex gap-8 pb-3 font-medium justify-between ml-2 mr-5 mt-5">
          <label className="text-grayNeutral/[0.6] font-inter text-xs ml-ten flex items-center">
            <img src={location} alt="location pin" className="h-6 w-6 cursor-pointer mr-2" />
            {address}
          </label>
          <label className="text-grayNeutral/[0.6] font-inter text-xs ml-ten flex items-center">
            <img src={mail} alt="email icon" className="h-6 w-6 cursor-pointer mr-2" />
            {emailAddress}
          </label>
          <label className="text-grayNeutral/[0.6] font-inter text-xs ml-ten flex items-center">
            <img src={phone} alt="phone icon" className="h-6 w-6 cursor-pointer mr-2" />
            {phoneNumber}
          </label>
        </div>
        <hr className="ml-4 mr-4 border-[0.5px] border-silver" />
        <textarea className="w-full text-grayNeutral font-inter font-medium text-xs m-ten ml-[18px] h-[60px] overflow-auto resize-none" value={bioDescription} rows={10} cols={10} readOnly />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    isPersonalInfoUpdated: state.talent.isPersonalInfoUpdated,
    personalInfoUserUpdated: state.talent.personalInfoUserUpdated,
    contactUserUpdated: state.talent.contactUserUpdated,
    isContactUpdated: state.talent.isContactUpdated,
    photos: state.talent.photos,
    userRating: state.talent.companyRating,
    userPayrollId: state.talent.payrollId,
    isEditActive: state.talent.isEditActive,
    activeEditField: state.talent.activeEditField,
    talentsData: state.talent.talentsData
  };
};

const mapDispatchToProps = {
  triggerUpdateCoreAttribute: updateCoreAttribute,
  triggerUpdateOtherAttributes: updateOtherAttributes,
  triggerUpdateEditActive: updateEditActive
};

export default connect(mapStateToProps, mapDispatchToProps)(TalentCard);
